import { useState } from "react";
import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export default function AtlasEndereco({ atlasEndereco }: { atlasEndereco: any }) {
  const [expandedRows, setExpandedRows] = useState<any>(undefined);
  const resultados: any[] = Array.isArray(atlasEndereco) ? atlasEndereco : [];

  const rowExpansionTemplate = (data: any) => {
    const telefones = data?.contatos?.telefones ?? [];
    const enderecos = data?.contatos?.enderecos ?? [];
    return (
      <div className="p-3">
        {enderecos.length > 0 && (
          <>
            <h5>Endereços</h5>
            <DataTable size="small" value={enderecos}>
              <Column field="tipo" header="Tipo"></Column>
              <Column field="logradouro" header="Logradouro"></Column>
              <Column field="numero" header="Número"></Column>
              <Column field="complemento" header="Complemento"></Column>
              <Column field="bairro" header="Bairro"></Column>
              <Column field="cidade" header="Cidade"></Column>
              <Column field="uf" header="UF"></Column>
              <Column field="cep" header="CEP"></Column>
            </DataTable>
          </>
        )}
        {telefones.length > 0 && (
          <>
            <h5>Telefones</h5>
            <DataTable size="small" value={telefones}>
              <Column field="tipo" header="Tipo"></Column>
              <Column field="ddd" header="DDD"></Column>
              <Column field="numero" header="Número"></Column>
              <Column field="uf" header="UF"></Column>
            </DataTable>
          </>
        )}
      </div>
    );
  };

  return (
    <div>
      <Panel header="Cadastral por Endereço">
        {resultados.length === 0 ? (
          <p>Nenhum registro encontrado.</p>
        ) : (
          <DataTable
            size="small"
            value={resultados}
            dataKey="cpf"
            expandedRows={expandedRows}
            onRowToggle={(e: any) => setExpandedRows(e.data)}
            rowExpansionTemplate={rowExpansionTemplate}
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column expander style={{ width: "3em" }} />
            <Column field="nome_completo" header="Nome"></Column>
            <Column field="cpf" header="CPF"></Column>
            <Column field="data_nascimento" header="Nascimento"></Column>
            <Column field="sexo" header="Sexo"></Column>
            <Column field="nome_mae" header="Nome da Mãe"></Column>
            <Column field="situacao_cadastral" header="Situação"></Column>
            <Column body={(row: any) => row?.socioeconomico?.renda_presumida} header="Renda Presumida"></Column>
          </DataTable>
        )}
      </Panel>
    </div>
  );
}
